<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button data-test="menuButton" auto-hide="false"></ion-menu-button>
        </ion-buttons>
        <ion-title data-test="title">Tests</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list>
        <ion-item data-test="smsItem" detail="true" id="btnSms" (click)="onSmsClick()" href="javascript:;">
            <ion-label class="ion-text-wrap">
                <span class="line1">Sms Test</span><br />
                <span class="line2">Send a text message to Michael.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="emailItem" detail="true" id="btnEmail" (click)="onEmailClick()" href="javascript:;">
            <ion-label class="ion-text-wrap">
                <span class="line1">Email Test</span><br />
                <span class="line2">Send an email to Michael.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="errorItem" detail="true" id="btnError" (click)="onErrorClick()" href="javascript:;">
            <ion-label class="ion-text-wrap">
                <span class="line1">Global Error Handler Test</span><br />
                <span class="line2">Throw an error and check if it is logged in Firestore.</span>
            </ion-label>
        </ion-item>

        <ion-item data-test="rewardItem" detail="true" id="btnReward" (click)="onRewardFunnelTestsClick()" href="javascript:;">
            <ion-label class="ion-text-wrap">
                <span class="line1">Reward Funnel Tests</span><br />
                <span class="line2">Individually test all rewards.</span>
            </ion-label>
        </ion-item>

    </ion-list>
</ion-content>